import * as $           from "jquery";
import { CommonResponse } from "../../Types/CommonResponse";
import jqXHR = JQuery.jqXHR;
import { getCurrentLanguage } from '../../Core/Languages';
import { RandProductsResponse } from "Components/Cart/types";

export interface CartServiceResponse extends CommonResponse {
	msg: string;
	type: string;
	redirect: string;
	result_code: string;
	cartThreshold: RandProductsResponse['cartThreshold'];
	value: {
		"count": number,
		"total": number,
		"modKey": string,
	};
}

export class CartService {
	public static add(lang: string, id: string, quantity?: number): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/add/${id}${quantity ? "/" + quantity : ""}/`);
	}
	public static remove(lang: string, id: string | number): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/delete/${id}/`);
	}
	public static clear(lang: string): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/clear_all/`);
	}
	public static clear_offer(lang: string): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/clear_all_offer/`);
	}
	public static update(id: string, quantity: number): jqXHR<CartServiceResponse> {
		const lang = getCurrentLanguage;
		return $.post(`/${lang}/a_cart/set/` + id, {value: quantity});
	}
	public static checkProductInTheBasket(lang: string): jqXHR<CartServiceResponse> {
		return $.ajax({url: `/${lang}/a_cart/check_product_in_the_basket/`, async: false});
	}

	public static getDeliveryTime(): jqXHR<string>{
		const lang = getCurrentLanguage;
		return $.get(`/${lang}/a_cart/get-delivery-time/`);
	}

	public static getAllBskCount() : jqXHR<any>{
		const lang = getCurrentLanguage;
		return $.get(`/${lang}/a_cart/get_all_bsk_count/`);
	}
}
import * as $           from "jquery";
import { CommonResponse } from "../../Types/CommonResponse";
import jqXHR = JQuery.jqXHR;
import { getCurrentLanguage } from '../../Core/Languages';
import { RandProductsResponse } from "Components/Cart/types";

export interface CartServiceResponse extends CommonResponse {
	msg: string;
	type: string;
	redirect: string;
	result_code: string;
	cartThreshold: RandProductsResponse['cartThreshold'];
	value: {
		"count": number,
		"total": number,
		"modKey": string,
	};
}

export class CartService {
	public static add(lang: string, id: string, quantity?: number): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/add/${id}${quantity ? "/" + quantity : ""}/`);
	}
	public static remove(lang: string, id: string | number): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/delete/${id}/`);
	}
	public static clear(lang: string): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/clear_all/`);
	}
	public static clear_offer(lang: string): jqXHR<CartServiceResponse> {
		return $.get(`/${lang}/a_cart/clear_all_offer/`);
	}
	public static update(id: string, quantity: number): jqXHR<CartServiceResponse> {
		const lang = getCurrentLanguage;
		return $.post(`/${lang}/a_cart/set/` + id, {value: quantity});
	}
	public static checkProductInTheBasket(lang: string): jqXHR<CartServiceResponse> {
		return $.ajax({url: `/${lang}/a_cart/check_product_in_the_basket/`, async: false});
	}

	public static getDeliveryTime(): jqXHR<string>{
		const lang = getCurrentLanguage;
		return $.get(`/${lang}/a_cart/get-delivery-time/`);
	}

	public static getAllBskCount() : jqXHR<any>{
		const lang = getCurrentLanguage;
		return $.get(`/${lang}/a_cart/get_all_bsk_count/`);
	}
}
